export const getPriceFilterDataFromOptions = (options) => {
  const localPriceFilterData = options.reduce(
    (total, opt) =>
      total.concat(opt?.value.split("_").map((val) => Number(val))),
    []
  );
  return [... new Set(localPriceFilterData)];
};

export const getNotAllowedRanges = (options) => {
  const localPriceFilterData = getPriceFilterDataFromOptions(options);
  let missingRangesArray = options.map(( opt, index) => {
    if (
      Number(opt.value.split("_")[1]) <
      Number(options[index + 1]?.value.split("_")[0])
    ) {
      return {
        min:localPriceFilterData.indexOf(Number(opt.value.split("_")[1])),
        max: localPriceFilterData.indexOf(Number(options[index + 1]?.value.split("_")[0])),
      }
    }
  });
  const missingRanges = missingRangesArray.filter(val => {
    if(val){
      return val
    }
  })
  return missingRanges
}

export const findClosestPriceFilterValue = (filterData, value, min = true) => {
  if (!value) return value;
  const numericValue = Number(value);
  for (var i = 0; i < filterData.length; i++) {
    const currentFilterData = Number(filterData[i]);
    if (currentFilterData == numericValue) {
      return i;
    }
    // if we find bigger we need to stop, calculate distance and return the correct one
    if (filterData[i] > numericValue) {
      return min ? i - 1 : i;
    }
  }
  return filterData.length - 1;
};

export const getAffordablePriceFilterDataFromOptions = (options, max, fixedVal = 0) => {
  let newArr = options.filter((value) => value <= max);

  let newMax = Number(fixedVal) > Number(max) ? max.toFixed() : fixedVal;
  if (newArr.length == 0) {
    newArr = [0, Number(newMax)];
  } else if (newArr.length == 1 && newArr[0] === 0) {
    newArr.push(Number(newMax));
  }
  if (newArr[newArr.length - 1] < newMax) {
    newArr.push(Number(newMax));
  }
  return newArr;
};
